var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneralInformationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9584 2.0416C9.54173 1.54993 10.4834 1.54993 11.0501 2.0416L12.3667 3.1666C12.6167 3.37493 13.0917 3.54993 13.4251 3.54993H14.8417C15.7251 3.54993 16.4501 4.27493 16.4501 5.15827V6.57493C16.4501 6.90827 16.6251 7.37493 16.8334 7.62493L17.9584 8.9416C18.4501 9.52493 18.4501 10.4666 17.9584 11.0333L16.8334 12.3499C16.6251 12.5999 16.4501 13.0666 16.4501 13.3999V14.8166C16.4501 15.6999 15.7251 16.4249 14.8417 16.4249H13.4251C13.0917 16.4249 12.6251 16.5999 12.3751 16.8083L11.0584 17.9333C10.4751 18.4249 9.5334 18.4249 8.96673 17.9333L7.65007 16.8083C7.40007 16.5999 6.92507 16.4249 6.60007 16.4249H5.14173C4.2584 16.4249 3.5334 15.6999 3.5334 14.8166V13.3916C3.5334 13.0666 3.36673 12.5916 3.1584 12.3499L2.0334 11.0249C1.55007 10.4499 1.55007 9.5166 2.0334 8.9416L3.1584 7.6166C3.36673 7.3666 3.5334 6.89993 3.5334 6.57493V5.1666C3.5334 4.28327 4.2584 3.55827 5.14173 3.55827H6.5834C6.91673 3.55827 7.3834 3.38327 7.6334 3.17493L8.9584 2.0416Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.7749V10.7999",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99536 13.3333H10.0028",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInformationIcon);
export default __webpack_public_path__ + "static/media/general-information-icon.6e01638c04bd3564fab6528654d12833.svg";
export { ForwardRef as ReactComponent };